import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import ErrorScreen from 'components/shared/ErrorScreen';
import { openMobileAppInfoModal } from 'components/shared/MobileAppInfo';
import Text from 'components/shared/Typography/Text';
import { showMobileInfoSelector } from 'store/app/selectors';
import { unauthorizedUserSelector } from 'store/auth/selectors';
import { logoutThunk } from 'store/auth/thunks';

import { GP_AUTH_SIGNIN_ROUTE } from '../Routes/constants';

function ForbiddenGuestPortal() {
  const dispatch = useDispatch();
  const user = useSelector(unauthorizedUserSelector);
  const { guestPortalId } = useParams();
  const showMobileInfo = useSelector(showMobileInfoSelector);
  const logout = () => dispatch(logoutThunk({ getSignInPath: () => GP_AUTH_SIGNIN_ROUTE }));
  const customHint = () => (
    <Text>
      {user?.email && (
        <div style={{ marginBottom: '2rem' }}>
          You’re currently logged in as
          <br />
          <b>{user.email}.</b>
        </div>
      )}
      <div>
        Please click below to log out and log back in
        <br />
        using the email address invited to this link in
        <br /> order to access this page.
      </div>
    </Text>
  );
  const customFooter = () => 'Press the Log Out button and log in again with the correct email';

  useEffect(() => {
    if (showMobileInfo) {
      openMobileAppInfoModal(`guest-portals/${guestPortalId}`, true);
    }
  }, [guestPortalId, showMobileInfo]);

  return (
    <ErrorScreen
      status="403"
      buttonAction={logout}
      buttonText="Log Out"
      customHint={customHint()}
      customFooter={customFooter()}
      hideStatusCode
    />
  );
}

export default ForbiddenGuestPortal;
